import Component from "../subscription"

export default Component
